import el from '@finn-no/create-element';
import { toast } from '@finn-no/common-browserbundle';

export default {
    dependencies: ['$element', 'favoritesservice', 'templateservice', 'radio'],
    callable(ele, favoritesService, templateService, radio) {
        const favoritedInFolders = getFavoritedFolders();
        const adId = ele.querySelector('[data-adid]').getAttribute('data-adid');
        const formEle = ele.querySelector('[data-create-list-form]');
        const nameInputEle = formEle.elements.name;
        const submitEle = formEle.elements.submit;
        const errorMessageEle = el('p.mhn.cherry', {
            id: 'new-list-error-message',
        });

        init();

        function init() {
            if (ele) {
                ele.addEventListener('click', handleToggleFavorite);
                ele.addEventListener('keydown', event => {
                    if (event.target.closest('[data-adid]')) {
                        handleItemKeydown(event);
                    }
                });
            }

            if (formEle) {
                formEle.addEventListener('submit', createList);
                nameInputEle.addEventListener('input', removeErrorMessage);
            }
        }

        function arrayToggle(arr, item) {
            const index = arr.indexOf(item);
            if (index === -1) {
                arr.push(item);
                return true;
            } else {
                arr.splice(index, 1);
                return false;
            }
        }

        function getFavoritedFolders() {
            return Array.from(ele.querySelectorAll('[data-folderid]'))
                .filter(e => e.getAttribute('data-favorited') === 'true')
                .map(e => e.getAttribute('data-folderid'));
        }

        function handleToggleFavorite(evt) {
            const ele = evt.target.closest('[data-favorited]');

            if (ele) {
                toggleFavorite(ele);
            }
        }

        function handleItemKeydown(event) {
            if (
                event.keyCode === 13 /* Enter */ ||
                event.keyCode === 32 /* Space */
            ) {
                event.stopPropagation();
                event.preventDefault();
                event.target.click();
            }
        }

        function toggleFavorite(ele) {
            const folderName = ele.querySelector('span[data-foldername]')
                .textContent;
            const folderId = ele.getAttribute('data-folderid');
            const isFavorite = arrayToggle(favoritedInFolders, folderId);
            ele = toggleItem(ele, isFavorite);
            syncToggleButton();
            favoritesService
                .toggleFavorite(folderId, adId, isFavorite)
                .then(() => showSuccessMessage(isFavorite, folderName))
                .catch(() => {
                    const isFavorite = arrayToggle(
                        favoritedInFolders,
                        folderId
                    );
                    toggleItem(ele, isFavorite);
                    syncToggleButton();
                });
        }

        function showSuccessMessage(isFavorite, folderName) {
            if (isFavorite) {
                toast({ message: `Lagret i ${folderName}` });
            } else {
                toast({ message: `Fjernet fra ${folderName}` });
            }
        }

        function toggleItem(itemEle, isFavorite) {
            const folderId = itemEle.getAttribute('data-folderid');
            const folderName = itemEle.querySelector('[data-foldername]')
                .textContent;
            const newItemEle = createItemElement(
                isFavorite,
                adId,
                folderId,
                folderName
            );
            itemEle.replaceWith(newItemEle);
            newItemEle.focus();

            window.setTimeout(hide.bind(null, ele), 300);
            return newItemEle;
        }

        function hide(target) {
            target.classList.add('hidden');
            target.setAttribute('aria-hidden', 'true');
            target.focus();
        }

        function syncToggleButton() {
            radio('favorites-toggle').broadcast(
                favoritedInFolders.length !== 0
            );
        }

        function createItemElement(isFavorite, adId, folderId, folderName) {
            const ele = el('div');
            ele.innerHTML = templateService.render('favorites.entry', {
                isFavorite,
                ad: {
                    adId,
                },
                folder: {
                    folderId,
                    folderName,
                },
            });
            return ele.firstElementChild;
        }

        function addErrorMessage(message) {
            nameInputEle.setAttribute('aria-invalid', true);
            nameInputEle.setAttribute('aria-describedby', errorMessageEle.id);
            errorMessageEle.textContent = message;
            formEle.after(errorMessageEle);
        }

        function removeErrorMessage() {
            nameInputEle.removeAttribute('aria-invalid');
            nameInputEle.removeAttribute('aria-describedby');
            errorMessageEle.remove();
        }

        function createList(event) {
            event.preventDefault();

            const folderName = nameInputEle.value;
            if (folderName.trim() === '') {
                return;
            }

            const progressEle = createItemElement(true, null, null, folderName);
            formEle.closest('li').before(progressEle);
            submitEle.classList.add('inprogress');
            nameInputEle.disabled = true;

            favoritesService
                .createList(folderName)
                .then(folderId => {
                    const ele = createItemElement(
                        true,
                        adId,
                        folderId,
                        folderName
                    );
                    toggleFavorite(ele);
                    formEle.closest('li').before(ele);
                    submitEle.focus();
                })
                .catch(message => {
                    addErrorMessage(message);
                    nameInputEle.disabled = false;
                    nameInputEle.focus();
                })
                .then(() => {
                    nameInputEle.disabled = false;
                    submitEle.classList.remove('inprogress');
                    progressEle.remove();
                });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoritesToggle.js